export enum FloatingActionButtonModel {
    OPEN = 'open',
    CLOSED = 'closed'
}
